import * as types from './mutation-types';


const mutations = {
    [types.SET_LOADING](state, loading) {
        state.loading = loading;
    },
    [types.UPDATE_USERINFO](state, payload){
        state.userInfo = payload.userInfo
    },
    [types.IS_SHARE](state, payload){
        state.isShare=payload
    },
    [types.SET_PAGE_HOVER](state, payload){
        state.pageHover=payload
    },
    [types.AUDIO_PLAY_DERAIL](state, payload){
        state.audioPlayDetail = payload.data
    },
    //播放器
    [types.SET_CURRENT_INDEX] (state, index) {
        state.currentIndex = index.index
    },
    [types.SET_PLAYING_STATE](state, flag){
        state.playing = flag
    },
    [types.SET_FULL_SCREEN](state, flag){
        state.fullScreen = flag
    },
    [types.AUDIO_PLAY_LIST](state, list){
        state.audioPlayList = list.list
    },
    [types.SET_SEQUENCE_LIST](state, list){
        state.sequenceList = list.list
    },
    [types.SET_PLAY_MODE](state, mode){
        state.mode = mode
    },


}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js